const sliders = document.querySelectorAll<HTMLElement>('.post-slider');

sliders.forEach((slider) => {
	const isTombstone = slider.closest('.block-post-slider--tombstone') !== null;

	new (window as Window).Swiper(slider, {
		slidesPerView: isTombstone ? 1 : 1.1,
		spaceBetween: 16,
		loop: isTombstone,
		breakpoints: {
			[window.impBreakpoints?.md ?? 768]: {
				slidesPerView: 2,
				spaceBetween: 24,
			},
			[window.impBreakpoints?.lg ?? 992]: {
				slidesPerView: isTombstone ? 4 : 3.1,
				spaceBetween: isTombstone ? 30 : 24,
			},
			[window.impBreakpoints?.xxl ?? 1304]: {
				slidesPerView: isTombstone ? 4 : 3,
				spaceBetween: isTombstone ? 50 : 24,
			},
		},
		navigation: {
			nextEl: '.slider-pagination__button--next',
			prevEl: '.slider-pagination__button--prev',
			disabledClass: 'slider-pagination__button--disabled',
		},
	});
});
